import Icon from 'components/Icon';
import styled from 'styled-components';
import { colorWhite, colorGrey100, colorGreen400, colorBlack900, fontFamilyRaleway } from 'styleUtils';
export var SectionMenuWrapper = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-1sf1c0t-0"
})(["width:100%;position:relative;"]);
export var Line = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-1sf1c0t-1"
})(["width:100%;border-bottom:2px solid ", ";position:absolute;bottom:0px;"], colorGrey100);
export var SectionMenuStyled = /*#__PURE__*/styled.ul.withConfig({
  componentId: "sc-1sf1c0t-2"
})(["overflow-x:auto;padding:0;white-space:nowrap;width:100%;scrollbar-width:none;-ms-overflow-style:none;", ";"], function (_ref) {
  var $visibleScroll = _ref.$visibleScroll;

  if ($visibleScroll) {
    return "\n        &::-webkit-scrollbar {\n          width: 3px;\n          height: 3px;\n        }\n      \n        &::-webkit-scrollbar-thumb {\n          background-color: rgba(0, 0, 0, 0.1);\n          border-radius: 3px;\n          max-height: 50px;\n        }\n      \n        &::-webkit-scrollbar-track {\n          background-color: ".concat(colorGrey100, ";\n        }\n      ");
  }

  return "\n      scrollbar-width: none;\n      -ms-overflow-style: none;\n    \n      &::-webkit-scrollbar {\n        display: none;\n      }\n    ";
});
export var SectionMenuItemStyled = /*#__PURE__*/styled.li.withConfig({
  componentId: "sc-1sf1c0t-3"
})(["list-style:none;display:inline-block;user-select:none;padding:12px 0;border-bottom:2px solid transparent;cursor:pointer;font:bold 12px/16px ", ";letter-spacing:0.1em;text-transform:uppercase;color:", ";position:relative;z-index:50;", ";&:not(:last-child){margin-right:16px;}&:last-child{margin-right:0;}&:hover{border-bottom:2px solid ", ";color:", ";}"], fontFamilyRaleway, colorBlack900, function (_ref2) {
  var isActive = _ref2.isActive;
  return isActive && "cursor: auto;\n    border-bottom: 2px solid ".concat(colorGreen400, ";\n    color: ").concat(colorGreen400, ";");
}, colorGreen400, colorGreen400);
export var SlideIcon = /*#__PURE__*/styled(Icon).withConfig({
  componentId: "sc-1sf1c0t-4"
})(["width:9px;"]);
export var PrevSlideBtn = /*#__PURE__*/styled.a.withConfig({
  componentId: "sc-1sf1c0t-5"
})(["width:22px;height:100%;display:flex;justify-content:flex-start;align-items:center;cursor:pointer;top:0;left:0;position:absolute;z-index:100;background:linear-gradient( 90deg,", " 0%,", " 67.51%,rgba(255,255,255,0) 127.08% );", ""], colorWhite, colorWhite, function (_ref3) {
  var isHidden = _ref3.isHidden;
  return isHidden && "display: none;";
});
export var NextSlideBtn = /*#__PURE__*/styled(PrevSlideBtn).withConfig({
  componentId: "sc-1sf1c0t-6"
})(["justify-content:flex-end;right:0;left:auto;background:linear-gradient( 270deg,", " 0%,", " 67.51%,rgba(255,255,255,0) 127.08% );"], colorWhite, colorWhite);